import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ValidationHandlerService, TranslatedToastrService, RetryViewComponent, BaseComponent, LanguageService, DataTableRequest,ImgWithSrcComponentFixWidth75px, StravaService, ViewComponent, StravaActivityLogListModel, ActivityLogStatus, ListItemModel, StravaActivityLogSearchData, SelectedListItemModel} from 'lib/Vestra.shared';
import { firstValueFrom } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthenticationService, VestraService } from 'src/app/services/api-services';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ADTSettings } from 'angular-datatables/src/models/settings';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { StravaActivityViewComponent } from '../../strava-activity/strava-activity-view/strava-activity-view.component';

@Component({
    selector: 'app-strava-webhook-list',
    templateUrl: './strava-webhook-list.component.html',
    styleUrls: ['./strava-webhook-list.component.scss'],
    standalone: false,
})
export class StravaWebhookListComponent extends BaseComponent implements OnInit, AfterViewInit {
    @ViewChild('actionsRef') actionsRef: TemplateRef<RetryViewComponent>;
    
    public stravaWebhookStatusList: SelectedListItemModel[] = [];
    public selectedStatusList: number[] = [];
    public selectedModifiedRange: Date[] | null = null;
    dropdownSettings: any;
    public form: FormGroup = this.getFormGroup();

    constructor(
        protected override validationHandlerService: ValidationHandlerService,
        private translatedToastrService: TranslatedToastrService,
        private translateService: TranslateService,
        protected override modalService: BsModalService,
        private stravaService: StravaService,
        private authenticationService: AuthenticationService,
        protected override spinnerService: NgxSpinnerService,
        protected override languageService: LanguageService,
        private router: Router,
        private route: ActivatedRoute
    ) {
        super(spinnerService, modalService, validationHandlerService, translateService, languageService);
    }

    public ngOnInit(): void {
        this.loadDropDownSettings();
        this.dataTableOnInit();
    }

    public ngAfterViewInit() {
        this.getStravaWebhookListConfig().then(() => this.dataTableAfterViewInit());
    }

    public ngOnDestroy() {
        this.dataTableOnDestroy();
    }

    public override getDtOptions() {
        this.languageUrl = this.languageService.getTranslationUrl();

        const res: ADTSettings = {
            serverSide: true,
            processing: false,
            pageLength: 20,
            lengthChange: false,
            responsive: {
                details: {
                    type: 'column',
                    target: -1,
                },
            },
            order: [[0, 'desc']],
            searching: false,
            destroy: true,
            language: {
                url: this.languageUrl,
            },
            ajax: (dataTablesParams: any, callback: any) => {
                const searchData: StravaActivityLogSearchData = {
                    propertyValue: this.searchValue,
                    statusList: this.selectedStatusList,
                    modifiedFrom: this.selectedModifiedRange?.[0],
                    modifiedTo: this.getNextDayStart(this.selectedModifiedRange?.[1]),
                };

                for (let order of dataTablesParams.order) {
                    order.name = dataTablesParams.columns[order.column]?.data;
                }

                const model: DataTableRequest = {
                    draw: dataTablesParams.draw,
                    start: dataTablesParams.start,
                    length: dataTablesParams.length,
                    order: dataTablesParams.order,
                    search: searchData,
                    columns: this.transformToColumnData(this.dtOptions.columns),
                };
                this.datatableRequest = model;

                this.handleSpinner(firstValueFrom(this.stravaService.getStravaActivityLogListDataSource(model)))
                    .then(res => {
                        callback(this.getTableData(res));
                        return Promise.resolve(res);
                    })
                    .catch((err: HttpErrorResponse) => {
                        this.validationHandlerService.handleServerError(err);
                        callback(this.getEmptyTableData());
                    });
            },
            createdRow: function (row, data: any, dataIndex) {
                let rowData = data as StravaActivityLogListModel;

                if (rowData.status === ActivityLogStatus.FailedSameActivityId
                    || rowData.status === ActivityLogStatus.FailedUnknown
                    || rowData.status === ActivityLogStatus.FailedSameEventTime
                    || rowData.status === ActivityLogStatus.FailedSameStartTime
                    || rowData.status === ActivityLogStatus.FailedNotSupportedManualActivity
                    || rowData.status === ActivityLogStatus.FailedNotContainInterpretableData
                ) {
                    $(row).find('td').css({
                        'background-color': '#d3d3d3',
                        'font-style': 'italic' 
                    });
                } 
            },
            columns: [
                {
                    data: 'id',
                    title: 'common.id',
                    searchable: false,
                    orderable: true,
                },
                {
                    data: 'modified',
                    title: 'common.modified',
                    searchable: false,
                    orderable: true,
                    render(data) {
                        return new Date(data).toLocaleString();
                    },
                },
                {
                    data: 'stravaUserId',
                    title: 'activity.user_id',
                    searchable: false,
                    orderable: true,
                },
                {
                    data: 'stravaUsername',
                    title: 'activity.username',
                    searchable: false,
                    orderable: true,
                },
                {
                    data: 'activityId',
                    title: 'activity.id',
                    searchable: false,
                    orderable: true,
                },
                {
                    data: 'calculatedCredit',
                    title: 'activity.calculated_credit',
                    searchable: false,
                    orderable: true,
                },
                {
                    data: 'status',
                    title: 'common.status',
                    searchable: false,
                    orderable: true,
                },
                {
                    title: 'common.actions',
                    data: null,
                    searchable: false,
                    orderable: false,
                    defaultContent: '',
                    ngTemplateRef: {
                        ref: this.actionsRef,
                        context: {
                            captureEvents: this.onRetryOrViewItem.bind(this),
                        },
                    },
                    responsivePriority: 1,
                },
                {
                    data: '',
                    orderable: false,
                    responsivePriority: 1,
                    render: function (data) {
                        return '';
                    },
                },
            ],
            columnDefs: [
                {
                    targets: '_all',
                    visible: true,
                },
                {
                    className: 'details-icon dtr-control',
                    orderable: false,
                    target: -1,
                },
            ],
        };

        return res;
    }

    public onSearch(): void {
        if (this.form.valid) {
            this.searchValue = this.form.value.propertyValue;
            this.selectedStatusList = (this.form.value.stravaWebhookStatusList ?? []).map((x: ListItemModel) => x.value);
            this.selectedModifiedRange = this.toDayRange(this.form.value.modifiedRange);
            this.refreshDataTable();
        }
    }

    public onClear(): void {
        this.form.reset({
            propertyValue: '',
            stravaWebhookStatusList: [],
            modifiedRange: null,
        });
        this.searchValue = null;
        this.selectedStatusList = [];
        this.selectedModifiedRange = null;
        this.refreshDataTable();
    }

    public onTryAgainWebhookProcess(activityId: number)
    {
        this.handleSpinner(firstValueFrom(this.stravaService.stravaActivityReprocess(activityId)))
            .then(res => {
                this.refreshDataTable();
                return Promise.resolve(res);
            })
            .catch((err: HttpErrorResponse) => {
                this.validationHandlerService.handleServerError(err);
            });
    }

    public onRetryOrViewItem(event: any) {
        console.log(event)
        if(event.action == "retry")
        {
            this.openConfirmDialog(undefined, () => this.onTryAgainWebhookProcess(event.data.id), null, 'activity.retry_title', 'activity.retry_confirm');
        }
        else if(event.action == "view")
        {
            this.openViewModalWithComponent(event.data.id);
        }
    }
    public openViewModalWithComponent(activityId: number) {
        console.log(activityId)
        let modalOptions: ModalOptions = this.getDefaultModalOptions('activity.title', activityId);
        let bsModalRef: BsModalRef = this.modalService.show(StravaActivityViewComponent, modalOptions);
    }

    //#region  Private functions
    private getFormGroup(): FormGroup {
        return new FormGroup({
            propertyValue: new FormControl(''),
            stravaWebhookStatusList: new FormControl([]),
            modifiedRange: new FormControl(null),
        });
    }
    private getStravaWebhookListConfig(): Promise<any> {
        return this.handleSpinner(
            firstValueFrom(this.stravaService.getStravaWebhookListConfig())
                .then(res => {
                    this.stravaWebhookStatusList = res.result.statusList;
                    this.setDefaultStatusList();
                    this.selectedModifiedRange = this.toDayRange([res.result.modifiedFrom, new Date()]);
                    this.form.controls['modifiedRange'].setValue(this.selectedModifiedRange);
                    return Promise.resolve(res);
                })
                .catch((err: HttpErrorResponse) => {
                    this.validationHandlerService.handleServerError(err);
                })
        );
    }
    //exclusive end of the range: start of the next local day (DST-safe, the local calendar knows the length of the day)
    private getNextDayStart(date: Date | null | undefined): Date | undefined {
        if (!date) {
            return undefined;
        }
        return new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
    }
    private setDefaultStatusList() 
    {
        const defaultStatusList: SelectedListItemModel[] = this.stravaWebhookStatusList.filter(x => x.isSelected);
        this.form.controls['stravaWebhookStatusList'].setValue(defaultStatusList);
        this.selectedStatusList = defaultStatusList.map(x => x.value);
    }
    private toDayRange(range: (Date | string)[] | null | undefined): Date[] | null {
        if (!range?.[0] || !range?.[1]) {
            return null;
        }
        return range.map(value => {
            const date = new Date(value);
            return new Date(date.getFullYear(), date.getMonth(), date.getDate());
        });
    }
    private loadDropDownSettings()
    {
        this.dropdownSettings = {
            singleSelection: false,
            idField: 'value',
            textField: 'text',
            itemsShowLimit: 3,
            allowSearchFilter: true,
            defaultOpen: false,
        };
    }
    //#endregion
}
